/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Jayati_NameInputs */

const en_marketing_app_jayati_name = /** @type {(inputs: Marketing_App_Jayati_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jayati S.`)
};

const es_marketing_app_jayati_name = /** @type {(inputs: Marketing_App_Jayati_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jayati S.`)
};

/**
* | output |
* | --- |
* | "Jayati S." |
*
* @param {Marketing_App_Jayati_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_jayati_name = /** @type {((inputs?: Marketing_App_Jayati_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Jayati_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_jayati_name(inputs)
	return en_marketing_app_jayati_name(inputs)
});